import { render, staticRenderFns } from "./photography.vue?vue&type=template&id=00529192&"
import script from "./photography.vue?vue&type=script&lang=js&"
export * from "./photography.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports